import { LimitsModal } from '../ui';
import { useModalStore } from '@/shared/lib';
import type { TransformedLimitsData } from './types';

type OpenLimitsDialogParams = {
  onBack: () => void;
  walletId: string;
  limitsMap: TransformedLimitsData;
};

export function useLimitsModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openLimitsDialog = ({
    onBack,
    walletId,
    limitsMap,
  }: OpenLimitsDialogParams) => {
    if (!limitsMap) return;

    showDialogComponent({
      component: (
        <LimitsModal
          onBack={onBack}
          walletId={walletId}
          limitsMap={limitsMap}
        />
      ),
      className:
        'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto bg-secondary-bg border-0 flex',
      onClose: closeDialog,
    });
  };

  return { openLimitsDialog };
}
